<template>
  <div>
    <div v-if="costTableVisibleTwo" class="maskDiv">
      <div class="costTable">
        <div style="position: sticky;top: 0;z-index: 10;">
          <div class="controlDiv">
            <div style="display:flex;width:1025px;justify-content:center;">
              <div style="display:flex;margin-right:250px;align-items:center;">
                <div class="controlDiv_button"  @click="showCostTableHead=true">打开数据汇总板</div>
                <i class="el-icon-arrow-down" style="font-size:18px;color:#ddd;margin-left: 5px;"></i>
              </div>
              <div style="display:flex;align-items:center;">
                <div class="controlDiv_button" @click="showCostTableHead=false">收起数据汇总板</div>
                <i class="el-icon-arrow-up" style="font-size:18px;color:#ddd;margin-left: 5px;"></i>
              </div>
            </div>
            <div class="shareIcon_box">
              <svg-icon style="width: 26px;height: 26px;" :iconClass="'share1'"></svg-icon>
              <div class="saveCostTable" @click="costTableVisibleTwo=false">关闭</div>
            </div>
          </div>
          <div class="costTableHead" v-show="showCostTableHead" style="height:2.75rem;">
            <div style="display:flex;justify-content: space-between;">
              <div>
                <div class="info_box">
                  <div style="margin-left:30px">行程编号：</div>
                  <div style="margin-left:15px;margin-right:30px;">{{planInfo.id}}</div>
                  <div style="border-left:2px solid #bbb;border-right:2px solid #bbb;padding:0 30px;max-width:420px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;" 
                    >{{planInfo.planName}}</div>
                  <div style="margin-left:30px;">
                    {{dateFormatYMD(budgetInfo.departureDate,"/")}}-{{dateFormatYMD(dateAddDay(budgetInfo.departureDate,planInfo.planDay-1).getTime(),"/")}}
                  </div>
                </div>
                <div class="costTableHead_body">
                  <div style="height:1.66rem;">
                    <div class="appraiser_box" style="height:1.66rem;">
                      <div>
                        <div class="appraiser_info" style="height:1.66rem;">
                          <div class="appraiser_info_box">
                            <div class="info_title">座右铭</div>
                            <div class="info_body">性价比永远是开心出行的首要前提</div>
                          </div>
                          <div class="appraiser_info_right">
                            <div class="info_box_right">
                              <div class="info_name">{{budgetInfo.createName}}</div>
                              <img class="info_avatar" :src="budgetInfo.imageUrl"/>
                            </div>
                            <div class="info_ability">
                              <div>资深定制师</div>
                              <div>共计处理定制需求105件</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="width:7rem;height:1.66rem;margin-left:10px;margin-top:20px;display:flex;justify-content: space-between;">
                    <div>
                      <div style="display:flex;">
                        <div class="stroke_info_item" style="width:2.24rem;margin-right: 0.1rem;">
                          <div class="distanceInfo">
                            <div>{{planInfo.planDay}}</div>
                            <div style="font-size:14px;color: rgba(86, 89, 118, 100);">天数</div>
                          </div>
                          <div class="distanceInfo">
                            <div>{{planInfo.countryNumber}}</div>
                            <div style="font-size:14px;color: rgba(86, 89, 118, 100);">国家</div>
                          </div>
                          <div class="distanceInfo">
                            <div>{{planInfo.cityNumber}}</div>
                            <div style="font-size:14px;color: rgba(86, 89, 118, 100);">城市</div>
                          </div>
                        </div>
                        <div class="stroke_info_item">
                          <div class="distanceInfo">
                            <div style="width:75px;height:30px;background:rgba(219, 78, 26, 0.6);text-align:center;line-height:30px;color:white;font-size:16px;">核算人数</div>
                            <div style="width:75px;height:25px;margin-top:5px;text-align:center;font-size:18px;color:#565976;line-height:25px;font-weight:bold;">{{budgetInfo.useNumber}}人</div>
                          </div>
                        </div>
                      </div>
                      <div class="quotation_box" style="background:'#F5F7FA';">
                        <div class="quotation_box_name">报价单 {{dateFormatYMDHM(budgetInfo.createTime,'-')+'报价'}}</div>
                      </div>
                    </div>
                    <div style="width:3.24rem;height:1.67rem;background:white;border-radius:5px;display:flex;justify-content:space-between;flex-direction:column;padding:10px;">
                      <div style="display:flex;justify-content:space-between;font-size:14px;color:#DB4E1A;align-items:flex-end;">
                        <div>行程总预算</div>
                        <div style="font-weight:bold;font-size:20px;">{{dataObj.saleTotalPrice}}￥</div>
                      </div>
                      <div style="display:flex;justify-content:space-between;font-size:14px;color:#3B7B1A;align-items:flex-end;">
                        <div>已抢/预定</div>
                        <div style="font-weight:bold;font-size:20px;">￥</div>
                      </div>
                      <div style="display:flex;justify-content:space-between;font-size:14px;color:#FF0206;align-items:flex-end;">
                        <div>预定确认中</div>
                        <div style="font-weight:bold;font-size:20px;">￥</div>
                      </div>
                      <div style="display:flex;justify-content:space-between;font-size:14px;color:#DB4E1A;align-items:flex-end;">
                        <div>预定已确认</div>
                        <div style="font-weight:bold;font-size:20px;">￥</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pieChart" >
                <div id="pieChart" style="width:3.53rem;height:3.5rem;"></div>
              </div>
            </div>
          </div>
          <div style="background:white;padding: 10px 20px;">
            <div style="display:flex;justify-content:space-between;height: 83px;align-items: center;border-bottom:1px solid #ddd;">
              <div style="display:flex;">
                <div style="width:0.4rem;height:0.59rem;font-size:0.2rem;color:white;text-align:center;background:#DB4E1A;line-height:0.29rem;">行<br>程</div>
                <div class="filter_box">
                  <div>
                    <el-checkbox  v-model="checkAllState" @change="handleCheckAllChange(2)">全部项目</el-checkbox>
                    <el-checkbox-group v-model="checkedStateList" @change="handleCheckedCitiesChange(2)">
                      <el-checkbox v-for="(value, key) in dataObj.statePriceMap" :label="Number(key)" :key="key">{{stockTypeMap[key].typeName}}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="costTableData" :style="showCostTableHead?'':'top: 144px;'">
          <trip-left-day :chenckBudget="budgetInfo" ref="tripLeftDay" :showShaft="2"></trip-left-day>
          <budget-detail :checkBudget="budgetInfo" :chooseStockTypes="checkedStateList" :showShaft="3" 
            :showCostPrice="false" :allStockTypes="allStockTypes" 
            :planProductShowStatus="true"></budget-detail>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {budgetMixin} from "./../mixin/budgetMixin"
import PlanApi from '@/components/Api/PlanApi.js'
import budgetDetail from '../children/budgetDetail.vue'
import tripLeftDay from '../tripLeftDay.vue'
export default {
  mixins:[budgetMixin],
  components:{budgetDetail,tripLeftDay},
  data(){
    return{
      costTableVisibleTwo:false,
      showCostTableHead:true,
      planInfo:{},
      budgetInfo:{},
      checkAllState:false,
      checkedStateList:[],
      allStockTypes:[],
    }
  },
  methods:{
    handleCheckAllChange(type){
      if(this.checkAllState){
        for(const key in this.dataObj.statePriceMap){
          this.checkedStateList.push(key)
        }
      }else{
        this.checkedStateList = []
      }  
    },
    handleCheckedCitiesChange(type){
      this.checkAllState = this.dataObj.statePriceMap.length==this.checkedStateList.length   
    },
    openDialogInquiry(planInfo,budgetInfo){
      this.costTableVisibleTwo=true
      this.planInfo = planInfo
      this.budgetInfo = budgetInfo
      this.planInfo.planDay = budgetInfo.planDay
      this.planInfo.countryNumber = budgetInfo.countrySize
      this.planInfo.cityNumber = budgetInfo.citySize
      this.$set(this.budgetInfo,'quotation',this.dateFormatYMDHM(this.budgetInfo.createTime,'-')+'报价')
      this.checkedStateList = []
      this.allStockTypes = []
      this.checkAllState = true
      this.budgetInfo.planDayList.forEach(element => {
        this.$set(element,"planDate",this.dateAddDay(this.budgetInfo.departureDate,element.planDay-1).getTime())
      });
      this.dataObj = budgetInfo.budgetDetailResult
      for(const key in budgetInfo.budgetDetailResult.statePriceMap){
        this.checkedStateList.push(Number(key))
        this.allStockTypes.push(Number(key))
      }
      //this.pieChart()  
      new PlanApi('plan').budgetList({budgetMainId:this.budgetInfo.id}).then(res => {
        if (res.status == 200) {
          this.budgetInfo.planDayList.forEach(e=>{
            var budgetDetails = res.data.filter(item=>item.day==e.planDay)
            budgetDetails.forEach(ee=>{
              var saleTotalPrice = 0;
              ee.details.forEach(detail => {
                saleTotalPrice = saleTotalPrice + (detail.ratio * detail.stockNumber)
              })
              this.$set(ee, 'totalPrice', 0)
              this.$set(ee, 'saleTotalPrice', saleTotalPrice)
            })
            this.$set(e,'budgetDetails',budgetDetails)
          })
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    openDialog(planInfo,budgetInfo){
      this.costTableVisibleTwo=true
      this.planInfo = planInfo
      this.budgetInfo = budgetInfo
      this.$set(this.budgetInfo,'quotation',this.dateFormatYMDHM(this.budgetInfo.createTime,'-')+'报价')
      this.checkedStateList = []
      this.allStockTypes = []
      this.checkAllState = true
      this.planInfo.planDays.forEach(element => {
        this.$set(element,"planDate",this.dateAddDay(this.budgetInfo.departureDate,element.planDay-1).getTime())
      });
      this.$set(this.budgetInfo,'planDayList',this.planInfo.planDays)
      this.dataObj = budgetInfo.budgetDetailResult
      //this.pieChart() 
      for(const key in budgetInfo.budgetDetailResult.statePriceMap){
        this.checkedStateList.push(Number(key))
        this.allStockTypes.push(Number(key))
      }
      new PlanApi('plan').addPlanViewNumber({budgetMainId:this.budgetInfo.id}).then(res => {});
      new PlanApi('plan').sysList(this.budgetInfo.id).then(res => {
        if (res.status == 200) {
          console.log('sxxx',this.budgetInfo.planDayList)
          this.budgetInfo.planDayList.forEach(e=>{
            var budgetDetails = res.data.filter(item=>item.day==e.planDay)
            budgetDetails.forEach(ee=>{
              var saleTotalPrice = 0;
              ee.details.forEach(detail => {
                saleTotalPrice = saleTotalPrice + (detail.ratio * detail.stockNumber)
              })
              this.$set(ee, 'totalPrice', 0)
              this.$set(ee, 'saleTotalPrice', saleTotalPrice)
            })
            this.$set(e,'budgetDetails',budgetDetails)
          })   
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.costTableData /deep/ .leftChild{
  position: relative !important;
  top: 0rem !important;
}
.maskDiv{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background:rgba(0,0,0,0.5);
  z-index:2000;
  .costTable{
    position: fixed;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 2017;
    height: 100%;
    background: white;
    overflow: hidden;
    padding-bottom: 0.2rem;
    .hotelIcon{
      background:#E64C65;
    }
    .restaurantIcon{
      background:#FACFA9;
    }
    .spotIcon{
      background:#C3B6E6;
    }
    .trafficIcon{
      background:#CEDD79;
    }
    .siteIcon{
      background:#71D4D4;
    }
    .guideIcon{
      background:#A3D2F6;
    }
    .visaIcon{
      background:#EE8394;
    }
    .officialInvitationIcon{
      background:#409EFF;
    }
    .charactIcon{
      background:#67C23A;
    }
    .businessIcon{
      background:#E6A23C;
    }
    .Icon_box{
      display:inline-block;
      width:50px;
      height:20px;
      line-height:20px;
      font-size:14px;
      color:white;
      border-radius:4px;
      text-align:center;
      margin-right:15px;
    }
    .controlDiv{
      width: 14.5rem;
      background: #E65019;
      height: 0.5rem;
      display: flex;
      padding: 0.1rem 0.2rem;
      justify-content: space-between;
      .controlDiv_button{
        font-size: 0.18rem;
        color: white;
        width: 1.5rem;
        height: 0.3rem;
        line-height: 0.3rem;
        border-bottom: 1px solid #ffffff;
        text-align: center;
        cursor: pointer;
        font-family: SourceHanSansSC-regular;
      }
      .shareIcon_box{
        width: 1.2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .saveCostTable{
          color: #505559;
          border-radius: 5px;
          text-align: center;
          height: 0.3rem;
          line-height: 0.3rem;
          width: 0.8rem;
          background: white;
          cursor: pointer;
        }
      }
    }
    .costTableHead{
      width: 14.5rem;
      height: 3.83rem;
      background: #E65019;
      padding: 0.1rem 0.2rem;
      box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.24);
      .info_box{
        width: 10.25rem;
        height: 0.62rem;
        color: rgba(80,85,89,0.7);
        font-size: 0.2rem;
        background: white;
        border-radius: 5px;
        display: flex;
        align-items: center;
      }
      .costTableHead_body{
        display: flex;
        .appraiser_box{
          width: 3.16rem;
          height: 1.91rem;
          border-radius: 5px;
          background: white;
          margin-top: 0.24rem;
          .appraiser_info{
            width: 3.16rem;
            height: 1.91rem;
            display: flex;
            align-items: center;
            .appraiser_info_box{
              width: 1.1rem;
              height: 1.26rem;
              margin-left: 0.3rem;
              padding: 0.2rem 0.2rem 0.2rem 0;
              border-right: 2px solid #ddd;
              color: #e38c09;
              .info_title{
                font-size: 0.16rem;
              }
              .info_body{
                width: 0.78rem;
                height: 0.67rem;
                font-size: 0.13rem;
                line-height: 0.24rem;
                margin-top: 0.1rem;
              }
            }
            .appraiser_info_right{
              padding: 0.05rem 0 0.2rem 0.2rem;
              height: 1.26rem;
              width: 1.96rem;
              .info_box_right{
                display: flex;
                align-items: center;
                .info_name{
                  font-weight: bold;
                  font-size: 0.16rem;
                  color: black;
                }
                .info_avatar{
                  width: 0.5rem;
                  height: 0.5rem;
                  border-radius: 50%;
                  background: url('/static/img/head.cf1e34c.jpg');
                  background-size: cover;
                  margin-left: 0.3rem;
                }
              }
              .info_ability{
                font-size: 0.13rem;
                color: #101010;
                line-height: 0.2rem;
                margin-top: 0.1rem;
              }
            }
          }
          .quotation_box{
            width: 3.17rem;
            height: 0.62rem;
            border-radius: 5px;
            background: white;
            display: flex;
            align-items: center;
            margin-top: 0.1rem;
            /deep/ .el-input__inner {
              border: 1px solid white;
              font-size: 0.18rem;
            }
              width: 100%;
            .blueButton{
              width: 0.69rem;
              height: 0.25rem;
              font-size: 0.13rem;
              font-weight: bold;
              color: white;
              text-align: center;
              line-height: 0.25rem;
              background: #02A0C6;
              border-radius: 2px;
              margin-left: 0.08rem;
              cursor: pointer;
            }
          }
        }
        .stroke_info_item{
          height: 0.94rem;
          background: white;
          display: flex;
          border-radius: 5px;
          align-items: center;
          justify-content: space-around;
          font-size: 0.38rem;
          padding: 0 0.15rem;
          font-family: SourceHanSansSC-regular;
          color: #565976;
          .distanceInfo{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
          }
        }
        .quotation_box{
          height: 0.62rem;
          border-radius: 5px;
          background: white;
          display: flex;
          align-items: center;
          margin-top: 0.1rem;
          font-size: 0.2rem;
          padding-left: 0.2rem;
        }
      }
      .pieChart{
        background: white;
        border-radius: 5px;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 0.05rem;
      }
    }
    .filter_box{
      display:flex;
      flex-direction:column;
      justify-content:space-around;
      margin-left:0.1rem;
      >div{
        display: flex;
      }
      /deep/ .el-checkbox{
        margin-right: 0.1rem !important;
      }
    }
  }
  .costTableData{
    position: absolute;
    overflow: auto;
    top: 363px;
    bottom: 1px;
    left: 0.2rem;
    right: 0.2rem;
    display: flex;
    .day_icon{
      width: 0.35rem;
      height: 0.35rem;
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACUklEQVRYR+2Xy2vUUBTGv3NnyhSlUrSVJOMjxZV20UL/gSkW7KRV3Lh2Vt0LdW3Fre6tG3Wj0KXTTkpRO3sf4EaKVDqMTjKtKCoo83ByJKHJvEp7pwSmi7kQuLm533d+OfcmOSF0uVGX4+NAgC/TSqLP4TfK2vYfWdiNa0MDxyvRCRndvgDWjDoHxqLDPH/GLD6QBfhqKCkBeiyj2xegYCgLBLrD4LvxTHFBFqATXRvA1nV9MFoqjbvBhMBNAqUY/MRx8FQWYC/dMaq8P2X++N3q0QRgGdoSwDdkA3U6j8DpKju3zpk7n31tAGAZKgeGjOxuXwdBByMHeIdsa9cREr6YBc7Hl+28e+4BWEl1EYQ5d62JKK2t2O/c8U7WspFsL509reiOQMrdUwCtaBlrtg5gqDsAhol5VDWLH32zb1eG1Kroe8ZEj+IZ67ns7duzisE1ut2qcx/piKB1L7DDI+pqMUfBICOrmfakbJDDzrOS6joIiZrDk2dXi9kAgEEfQJg/rLG0jnGfwGNtANIGIU30X1L1JQD9BHiwwf9lSLF8m6ndjuO+Yir/nMv62vbro7MH0O1N2APoZaCXgV4GupaB78mTJ8oU+9X4jQ75GxDYWTPqBBhvvYEIXdTS1oZXEdmG8oJBV1srojBBmisifCr/jY2NZHMlDyCfPH0hSpHNIGC9JgyPoaEmFEJMKcuFV0FJ5mUhqVyCoCVmjIYXtdmJiC1muqdl7If+laayfCuh98cGKnqt6ihhQ8Si0cJwrT9P5ma50fvAf8OwQVr9ug7wH/8HmjAEHOudAAAAAElFTkSuQmCC) no-repeat;
      background-size: 0.35rem 0.35rem;
      font-weight: bold;
      color: #db4e1a;
      text-align: center;
      line-height: 0.45rem;
      font-size: 0.12rem;
    }
    .dateSpan{
      color:#99330D;
      font-size:0.16rem;
      font-weight:bold;
    }
    .spotBg_box{
      display:inline-block;
      width:0.93rem;
      height:0.23rem;
      color:white;
      background:url('../../../../assets/png/bg1.png');
      background-size: contain;
      background-repeat: no-repeat;
      line-height: 0.23rem;
      text-align: center;
      margin-left: 0.1rem;
      font-weight:bold;
      font-size: 0.12rem;
    }
  }
}
</style>